<template>
  <nav id="nav" class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          Cobalt Pig Development
        </a>
        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navMenu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu is-hidden-desktop" id="navMenu">
        <a class="navbar-item has-text-dark" href="#about">
          About Us
        </a>
        <a class="navbar-item has-text-dark" href="#services">
          Services
        </a>
        <a class="navbar-item has-text-dark" href="#customers">
          Customers
        </a>
        <div class="navbar-item">
          <a class="button is-dark" href="#contact-us">Contact Us</a>
        </div>
      </div>
      <div class="navbar-end is-hidden-touch">
        <a class="navbar-item has-text-dark" href="#about">
          About Us
        </a>
        <a class="navbar-item has-text-dark" href="#services">
          Services
        </a>
        <a class="navbar-item has-text-dark" href="#customers">
          Customers
        </a>
        <div class="navbar-item">
          <a class="button is-dark" href="#contact-us">Contact Us</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  name: 'Nav',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
